<template>
  <span class="text-with-links">
    <template v-for="part in textParts">
      <a
        v-if="part.isUrl"
        :key="`url-${part.key}`"
        :href="part.href"
        target="_blank"
        rel="noopener noreferrer"
        :class="linkClass"
      >
        {{ part.text }}
      </a>
      <span v-else :key="`text-${part.key}`">{{ part.text }}</span>
    </template>
  </span>
</template>

<script>
import { splitTextWithUrlParts } from '../../../utils/textWithUrls.js'

export default {
  name: 'TextWithLinks',
  props: {
    text: {
      type: String,
      required: true
    },
    linkClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    textParts() {
      return splitTextWithUrlParts(this.text)
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  overflow-wrap: break-word;
  word-break: break-all;
}
</style>
